module.exports = [
  {
    id: 'watchpls',
    img: 'img/software/watchpls.png',
    mainIcon: 'play',
    title: 'WatchPls',
    desc: 'WatchPls is an ecosystem of apps that allow you to share anything and everything happening on your pc to others. It is P2P so the service has minimal overhead and allows you full control over your data. I decided to work on this because similar services (like rabbit), went away and the alternatives were all lacking. WatchPls is not complete, but its in a state where I enjoy it over alternatives.',
    tags: [
      {title: 'Content Sharing', icon: 'share-alt'},
      {title: 'P2P', icon: 'people-carry'},
      {title: 'Easy setup', icon: 'smile'},
    ],
    buttons: [
      {title: 'github', icon: ['fab', 'github'], link: 'https://github.com/watchpls-me', color: 'primary'},
      {title: 'Try it!', icon: '', link: 'https://chrome.google.com/webstore/detail/watchpls/iiccelmcaeljhopnbmofjnfpgpddmnpd', color: 'warning'},
    ]
  },
  {
    id: 'starboard',
    img: 'img/software/starboard.png',
    mainIcon: 'star',
    title: 'Starboard',
    desc: 'Starboard (also known as the smugboard&trade;) is a Discord.js bot that allows users to react to messages on a given server, and pin messages that reach a threshold to a special channel. Works great for big servers where users want to see the latest and greatest posts, art, and straight up weird content the server has to offer.',
    tags: [
      {title: 'NodeJS', icon: ['fab', 'js-square']},
      {title: 'Simple and flexible', icon: 'code-branch'},
      {title: 'Easy setup (no databases)', icon: 'smile'},
    ],
    buttons: [
      {title: 'github', icon: ['fab', 'github'], link: 'https://github.com/Rushnett/starboard', color: 'primary'}
    ]
  },
  {
    id: 'autograde',
    img: 'img/software/autograde.png',
    mainIcon: 'tasks',
    title: 'Autograde',
    desc: 'Autograde is a system designed for instructors to create test driven projects that they can easily release to students. It allows extensive customization and simplistic yet robust feedback. I designed the front end of Autograde alongside <a href="https://gose.pw/" target="_blank">Adrian Gose\'s</a> backend under the supervision of professors from the University of Alabama at Birmingham and Syracuse University.',
    tags: [
      {title: 'VueJS', icon: ['fab', 'vuejs']},
      {title: 'Classroom focused', icon: 'university'},
      {title: 'Feature rich', icon: 'check'},
    ],
    buttons: []
  },
  {
    id: 'saladboxadventure',
    img: 'img/software/mc_and_marshy.gif',
    mainIcon: 'gamepad',
    title: 'Saladbox Adventure',
    desc: 'Saladbox Adventure is an unfinished Phaser game (and likely will never be finished). Its goal was simply for learning purposes to entertain the possibility of creating a game in a robust javascript framework. I mainly worked on the pixel artwork and animations.',
    tags: [
      {title: 'Phaser', icon: ['fab', 'node-js']},
      {title: 'Web based game', icon: 'gamepad'},
    ],
    buttons: [
      {title: 'github', icon: ['fab', 'github'], link: 'https://github.com/Keiaxx/saladboxgame', color: 'primary'},
      {title: 'Demo', icon: '', link: 'https://keiaxx.github.io/saladboxgame/', color: 'warning'},
    ]
  }
]